import { StoreState } from '../../../store/store.interface';

/*----- SELECTORS ------*/
export const selectSuggestions = (state: StoreState, id: string) => state.suggestionsState?.suggestions[id]?.data;
export const isLoading = (state: StoreState, id: string) => state.suggestionsState?.suggestions[id]?.isLoading;
export const isLoaded = (state: StoreState, id: string) => state.suggestionsState?.suggestions[id]?.isLoaded;
export const isSuccess = (state: StoreState, id: string) => state.suggestionsState?.suggestions[id]?.isSuccess;
export const isFailure = (state: StoreState, id: string) => state.suggestionsState?.suggestions[id]?.isFailure;
